export default function Footer() {
  return (
    <footer className="flex justify-center">
      <div className="flex max-w-[960px] flex-1 flex-col">
        <footer className="flex flex-col gap-6 px-5 py-10 text-center @container">
          <div className="flex flex-wrap items-center justify-center gap-6 @[480px]:flex-row @[480px]:justify-around">
            <a className="text-[#4e977f] text-base font-normal leading-normal min-w-40" href="/about">About Us</a>
            <a className="text-[#4e977f] text-base font-normal leading-normal min-w-40" href="/gallery">Gallery</a>
            <a className="text-[#4e977f] text-base font-normal leading-normal min-w-40" href="/contact">Contact</a>
          </div>
          <p className="text-[#4e977f] text-base font-normal leading-normal">
            @2026 Eklavya Ashram School. All rights reserved.
          </p>
        </footer>
      </div>
    </footer>
  );
}
